import LandmarkTrigger from './landmark-trigger';

/**
 * Click-Landmark. Will be triggered if user clicks on a tag that is marked with `jsh-landmark__click`.
 * @param {HTMLElement} element Element which possesses this landmark.
 * @param {object} data Landmark configuration data. Cannot be null.
 * @param {function} sendLandmark Function to send data to the landmark service. Cannot be null.
 */
export default function(element, data, sendLandmark) {
    element.addEventListener('mousedown', () => {
        data.landmark = data.landmark || 'userinterface';

        if (LandmarkTrigger.shouldTriggerLandmark(element)) {
            sendLandmark(data);
        }
    });
}